import React, { useState, useEffect } from "react";
import {
    FormGroup,
    Label,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
import fetchApi from "components/Api/Actions";

function ModalAccounts({ item, buttonLabel, updateState, url }) {
    const [modal, setModal] = useState(false);
    const [form, setForm] = useState({
        roles: [],
        sections: [],
        permissions: {},
    });

    const toggle = () => setModal(!modal);

    const fetchAccountConfig = async () => {
        try {
            const config = await fetchApi(`account/permission/${item.id}`);
            setForm(config);
        } catch (error) {
            console.error("Error al obtener configuración de la cuenta:", error);
        }
    };

    const handleSubmit = async () => {
        try {
            // Aquí deberías usar tu lógica para enviar el formulario (ej: PUT/PATCH)
            await fetchApi(`account/permission/${item.id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(form),
            });

            updateState({ ...item, ...form }); // actualizar tabla padre si corresponde
            toggle();
        } catch (error) {
            console.error("Error al guardar cambios:", error);
        }
    };

    useEffect(() => {
        if (modal) {
            fetchAccountConfig();
        }
    }, [modal]);

    return (
        <>
            <Button color="info" size="sm" onClick={toggle}>
                {buttonLabel}
            </Button>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Editar cuenta: {item.name}</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Permisos por sección:</Label>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Sección</th>
                                    {form.roles.map((role) => (
                                        <th key={role} style={{ textTransform: "capitalize" }}>
                                            {role}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {form.sections.map((section) => (
                                    <tr key={section}>
                                        <td style={{ textTransform: "capitalize" }}>
                                            {section.replace(/_/g, " ")}
                                        </td>

                                        {form.roles.map((role) => (
                                            <td key={role} className="text-center">
                                                <Input
                                                    type="checkbox"
                                                    checked={!!form.permissions?.[section]?.[role]}
                                                    onChange={(e) =>
                                                        setForm((prev) => ({
                                                            ...prev,
                                                            permissions: {
                                                                ...prev.permissions,
                                                                [section]: {
                                                                    ...prev.permissions[section],
                                                                    [role]: e.target.checked,
                                                                },
                                                            },
                                                        }))
                                                    }
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Guardar
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                        Cancelar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default ModalAccounts;
